module.exports = __webpack_public_path__ + "img/blank-board.648800de.svg";